import { Action } from 'redux';

import ActionFetchActivitySuccess from '../interfaces/actions/ActionFetchActivitySuccess';
import ActionPayloadString from '../interfaces/actions/ActionPayloadString';
import ActionFetchActivityMonth from '../interfaces/actions/ActionFetchActivityMonth';
import ActionPayloadAny from '../interfaces/actions/ActionPayloadAny';
import AnyArrayData from '../interfaces/AnyArrayData';
import Month from '../interfaces/Month';

import * as Const from '../constants';

export const fetchActivityInit = (): Action => {
  return {
    type: Const.FETCH_ACTIVITY_INIT,
  };
};

export const fetchActivityPending = (): Action => {
  return {
    type: Const.FETCH_ACTIVITY_PENDING,
  };
};

export const fetchActivitySuccess = (payload: AnyArrayData): ActionFetchActivitySuccess => {
  return {
    type: Const.FETCH_ACTIVITY_SUCCESS,
    payload,
  };
};

export const fetchActivityError = (): Action => {
  return {
    type: Const.FETCH_ACTIVITY_ERROR,
  };
};

export const fetchActivityYear = (payload: string): ActionPayloadString => {
  return {
    type: Const.FETCH_ACTIVITY_YEAR,
    payload,
  };
};

export const fetchActivityMonth = (payload: Month): ActionFetchActivityMonth => {
  return {
    type: Const.FETCH_ACTIVITY_MONTH,
    payload,
  };
};

export const fetchActivityCurrDay = (payload: any): ActionPayloadAny => {
  return {
    type: Const.FETCH_ACTIVITY_CURRENT_DAY,
    payload,
  };
};
